import PropTypes from "prop-types";
import React from "react";
import { Label, Input, InputGroup } from "reactstrap";

const FormItem = (props) => {
  const {
    name,
    value,
    handleOnChange,
    id,
    title,
    indexToChange,
    keyToChange,
    isTextArea,
    icon,
  } = props;

  let inputFiled = isTextArea ? (
    <Input
      type="textarea"
      rows="6"
      name={name}
      value={value}
      onChange={(e) => handleOnChange(e, indexToChange, keyToChange)}
      id={id}
    />
  ) : (
    <Input
      name={name}
      value={value}
      onChange={(e) => handleOnChange(e, indexToChange, keyToChange)}
      id={id}
    />
  );

  if (id === "map.zoom") {
    inputFiled = (
      <Input
        type="number"
        min="0"
        max="100"
        name={name}
        className="form-control mb-1"
        value={value}
        onChange={handleOnChange}
        id={id}
      />
    );
  }

  const content = icon ? (
    <div>
      <Label htmlFor="name">{title}</Label>
      <InputGroup>
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className={icon} />
          </span>
        </div>
        {inputFiled}
      </InputGroup>
    </div>
  ) : (
    <div className="form-group w-100">
      <Label htmlFor="name">{title}</Label>
      {inputFiled}
    </div>
  );

  return <section>{content}</section>;
};

FormItem.defaultProps = {
  indexToChange: undefined,
  keyToChange: undefined,
  title: null,
  isTextArea: false,
  icon: null,
};

FormItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  indexToChange: PropTypes.number,
  keyToChange: PropTypes.string,
  isTextArea: PropTypes.bool,
  icon: PropTypes.string,
};

export default FormItem;



// WEBPACK FOOTER //
// ./client/react/Admin/components/FormItem/index.jsx